import dayjs from 'dayjs';

export function calculateTotals({
  subscriptionType,
  quantityUnit,
  quantity = 1,
  existingSubscription,
  promotionCode,
}) {
  let total = (subscriptionType[`${quantityUnit}Price`] * quantity).toFixed(2);
  const existingSubscriptionDiscount = calculateDiscountForExistingSubscription(
    { subscriptionType, existingSubscription }
  );
  const totalWithoutDiscount = total;
  if (existingSubscriptionDiscount) {
    total = (total - existingSubscriptionDiscount).toFixed(2);
    if (total < 0) {
      total = (0).toFixed(2);
    }
  }
  if (promotionCode) {
    const { type, value } = promotionCode;
    if (type == 'percent') {
      total = (total - (total * value) / 100).toFixed(2);
    } else if (type == 'amount') {
      total = (total - value).toFixed(2);
    }
    if (total < 0) {
      total = (0).toFixed(2);
    }
  }
  return { total, totalWithoutDiscount };
}

export function calculateDiscountForExistingSubscription({
  subscriptionType,
  existingSubscription,
}) {
  let discount = 0;
  if (
    existingSubscription?.status == 'active' &&
    !existingSubscription?.trial &&
    existingSubscription.subscriptionTypeId != subscriptionType.id
  ) {
    const { expirationDate, subscriptionType: existingSubscriptionType } =
      existingSubscription;
    const today = dayjs();
    const daysLeft = dayjs(expirationDate).diff(today, 'day');
    if (daysLeft > 0) {
      const pricePerDay = existingSubscriptionType.yearPrice / 365;
      discount = Math.floor(pricePerDay * daysLeft);
    }
  }
  return discount.toFixed(2);
}
